export const FETCH_COURSE_ENROLLMENTS_REQUEST = 'FETCH_COURSE_ENROLLMENTS_REQUEST';
export const FETCH_COURSE_ENROLLMENTS_SUCCESS = 'FETCH_COURSE_ENROLLMENTS_SUCCESS';
export const FETCH_COURSE_ENROLLMENTS_FAILURE = 'FETCH_COURSE_ENROLLMENTS_FAILURE';
export const CLEAR_COURSE_ENROLLMENTS = 'CLEAR_COURSE_ENROLLMENTS';
export const UPDATE_COURSE_RUN_STATUS = 'UPDATE_COURSE_RUN_STATUS';
export const UPDATE_IS_MARK_COURSE_COMPLETE_SUCCESS = 'UPDATE_IS_MARK_COURSE_COMPLETE_SUCCESS';
